import * as React from 'react';
import omit from 'lodash/omit';
import useRouterLink from '../hooks/useRouterLink';
import BaseButton from "@insolus/ui-kit/components/Button";
var Button = React.forwardRef(function Button(props, ref) {
  var _useRouterLink = useRouterLink(props),
      href = _useRouterLink.href,
      handleClick = _useRouterLink.handleClick;

  var to = props.to,
      isStatic = props.static;
  var otherLinkProps = omit(props, ['static', 'replace']);

  if (!to || isStatic) {
    return React.createElement(BaseButton, Object.assign({}, otherLinkProps, {
      ref: ref
    }));
  }

  return React.createElement(BaseButton, Object.assign({}, otherLinkProps, {
    to: href,
    ref: ref,
    onClick: handleClick
  }));
});
Button.defaultProps = {
  to: undefined,
  static: false,
  replace: false,
  target: undefined,
  onClick: undefined
};
export default Button;